import React, {useRef, useState} from 'react';
import propertyWriter from '../../lib/urlWriters/webURL';
import PropTypes from 'prop-types';
import styles from './Members.scss';
import Close from '@material-ui/icons/Close';
import UntrackModal from '../Modal/UntrackModal/UntrackModal';
import {isOnMobileDevice} from '../../lib/share';

const TrackedPropertyItem = (props) => {

  const {
    index,
    trackedProperties,
    property,
    formattedProperty,
    deleteProfileWatch,
    pathname,
  } = props;

  const propertyRef = useRef(null);
  const [showShareDropdown, setShowShareDropdown] = useState(false);
  const [showUntrackPropertyModal, setShowUntrackPropertyModal] = useState(false);

  const handleShowShareDropdownChange = () => {
    if (navigator.share && isOnMobileDevice(navigator)) {
      navigator.share({
        title: property.propertyDetails.address.formattedAddress,
        text: 'Check out this property I found on OnTheHouse: ',
        url: window.location.href,
      }).then(() => {});
    } else {
      setShowShareDropdown(!showShareDropdown);
    }
  };

  const toggleUntrackPropertyModal = () => {
    setShowUntrackPropertyModal(!showUntrackPropertyModal);
  };

  const untrackProperty = () => {
    deleteProfileWatch({propertyId: property.propertyId});
    toggleUntrackPropertyModal();
  };

  return <div className={`d-flex justify-content-between align-items-center pt-4 
            ${index === trackedProperties.subscribedProperties.length - 1 ? 'pb-4' : ''}`} key={index}>
    <div className={styles.addressLine}>
      <img src={`${property.propertyImageList && property.propertyImageList.url ? property.propertyImageList.url
        : '/assets/images/icon_happy.svg'}`} />
      <a href={propertyWriter(property.propertyDetails)}>
        {formattedProperty.address.formattedAddress}
      </a>
    </div>
    <div className={'d-flex'}>
      <div className={styles.untrackLabel} onClick={() => toggleUntrackPropertyModal()}
        title="Remove notification">
        <label className={styles.buttonLabel}>Untrack</label>
        <Close />
      </div>
      <UntrackModal isPropertyUntrackModal={true}
        showModal={showUntrackPropertyModal}
        handleCloseModalChange={() => toggleUntrackPropertyModal()}
        handleUntrackButtonClick={() => untrackProperty()}
      />
    </div>

  </div>;
};

TrackedPropertyItem.propTypes = {
  index: PropTypes.number,
  trackedProperties: PropTypes.object,
  property: PropTypes.object,
  formattedProperty: PropTypes.object,
  deleteProfileWatch: PropTypes.func,
  pathname: PropTypes.string,
};

export default TrackedPropertyItem;